import React, {Component} from 'react';
import InputElement from 'react-input-mask';

export default class EditAccount extends Component {
    constructor(props) {
        super(props);
        this.activeChangePassword = this.activeChangePassword.bind(this);
        this.clickEditAccount = this.clickEditAccount.bind(this);
        this.btnPromoCode = this.btnPromoCode.bind(this);

        this.state = {
            isChangePassword: false
        }
    }

    btnPromoCode(e) {
        e.preventDefault();
        this.props.handlePromoCode()
    }

    clickEditAccount(e) {
        e.preventDefault();
        this.props.handleClickEditAccount(this.props.user.id)
    }

    onFieldChange(fieldName, e) {
        if (typeof this.props.handleInputChange === 'function') {
            this.props.handleInputChange(fieldName, e.target.value)
        }
    }

    onBtnBack(component_name) {
        this.props.handleBtnBack(component_name)
    }

    activeChangePassword() {
        this.state.isChangePassword ? this.setState({isChangePassword: false}) : this.setState({isChangePassword: true})
    }

    render() {
        let user = this.props.user;
        let validField = this.props.validField;
        let errorMessageFirstName = '';
        let errorMessageLastName = '';
        let errorMessageCardName = '';
        let errorMessageCardNumber = '';
        let errorMessageSecurityNumber = '';
        let errorMessageCardMonth = '';
        let errorMessageCardYear = '';
        let errorMessagePostalCode = '';
        let errorMessageFirstAddr = '';
        let errorMessageCity = '';
        let errorMessagePhoneNumber = '';
        let errorMessagePassword = '';
        let errorMessageOldPassword = '';
        let errorMessagePasswordConfirmation = '';
        let errorMessagePromoCode = '';

        for (let el in validField) {
            if (el === 'first_name' && validField[el] === 'empty') {
                errorMessageFirstName = <em id="email-error" class="state-error">Please enter first name.</em>
            } else if (el === 'first_name' && validField[el] === 'many') {
                errorMessageFirstName = <em id="email-error" class="state-error">First name is too more.</em>
            } else if (el === 'last_name' && validField[el] === 'empty') {
                errorMessageLastName = <em id="email-error" class="state-error">Please enter last name.</em>
            } else if (el === 'last_name' && validField[el] === 'many') {
                errorMessageLastName = <em id="email-error" class="state-error">Last name is too more.</em>
            } else if (el === 'cardname' && validField[el] === 'empty') {
                errorMessageCardName = <em id="email-error" class="state-error">Please enter name On card.</em>
            } else if (el === 'cardname' && validField[el] === 'invalid') {
                errorMessageCardName = <em id="email-error" class="state-error">Please enter a valid card name.</em>
            } else if (el === 'cardno' && validField[el] === 'empty') {
                errorMessageCardNumber = <em id="email-error" class="state-error">Please enter credit card number.</em>
            } else if (el === 'cardno' && validField[el] === 'invalid') {
                errorMessageCardNumber = <em id="email-error" class="state-error">Please enter a valid card number.</em>
            } else if (el === 'secno' && validField[el] === 'empty') {
                errorMessageSecurityNumber = <em id="email-error" class="state-error">Please enter security number.</em>
            } else if (el === 'cardmonth' && validField[el] === 'empty') {
                errorMessageCardMonth = <em id="email-error" class="state-error"> Please enter expiration date.</em>
            } else if (el === 'cardyear' && validField[el] === 'empty') {
                errorMessageCardYear = <em id="email-error" class="state-error"> Please enter expiration date</em>
            } else if (el === 'zip' && validField[el] === 'invalid') {
                errorMessagePostalCode = <em id="email-error" class="state-error">Looks like we don't travel to your area. But contact us! We try our best to accomodate any location.</em>
            } else if (el === 'zip' && validField[el] === 'invalid_format') {
                errorMessagePostalCode = <em id="email-error" class="state-error">Please enter a valid postal code.</em>
            } else if (el === 'zip' && validField[el] === 'empty') {
                errorMessagePostalCode = <em id="email-error" class="state-error">Please enter postal code.</em>
            } else if (el === 'firstaddr' && validField[el] === 'empty') {
                errorMessageFirstAddr = <em id="email-error" class="state-error">Please enter address.</em>
            } else if (el === 'firstaddr' && validField[el] === 'long') {
                errorMessageFirstAddr = <em id="email-error" class="state-error">Please enter shorter address.</em>
            } else if (el === 'city' && validField[el] === 'empty') {
                errorMessageCity = <em id="email-error" className="state-error">Please enter city.</em>
            } else if (el === 'mobile' && validField[el] === 'invalid') {
                errorMessagePhoneNumber = <em id="email-error" class="state-error">Please enter valid phone number.</em>
            } else if (el === 'newPassword' && validField[el] === 'empty') {
                errorMessagePassword = <em id="email-error" class="state-error">Please enter password.</em>
            } else if (el === 'confirmPassword' && validField[el] === 'not_match') {
                errorMessagePasswordConfirmation =
                    <em id="email-error" class="state-error">Please enter a valid confirmation password.</em>
            } else if (el === 'confirmPassword' && validField[el] === 'empty') {
                errorMessagePasswordConfirmation =
                    <em id="email-error" class="state-error">Please enter confirmation password.</em>
            } else if (el === 'oldPassword' && validField[el] === 'empty') {
                errorMessageOldPassword = <em id="email-error" class="state-error">Please enter old password.</em>
            } else if (el === 'promo_code' && validField[el] === 'invalid') {
                errorMessagePromoCode = <em id="email-error" class="state-error">The code is invalid. Please try again.</em>
            }
        }

        return (
            <div className="smart-forms smart-container wrap-2">
                <div className="form-header header-lite">
                    <h4>My Account</h4>
                </div>
                <div className="form-body smart-steps steps-theme-primary">
                    <form method="post" action="#" id="smart-form">
                        <fieldset>
                            <div id="ctr_personal">
                                <div className="frm-row">
                                    <div className="section colm colm6">
                                        <label for="firstName" className="field-label">First Name</label>
                                        <label
                                            className={Object.keys(errorMessageFirstName).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="firstname"
                                                id="firstname"
                                                className="gui-input"
                                                placeholder="First Name"
                                                defaultValue={user.first_name}
                                                onChange={this.onFieldChange.bind(this, 'first_name')}
                                            />
                                            <span className="field-icon"><i className="fa fa-user"></i></span>
                                        </label>
                                        {
                                            errorMessageFirstName
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label for="lastName" className="field-label">Last Name</label>
                                        <label
                                            className={Object.keys(errorMessageLastName).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="lastname"
                                                id="lastname"
                                                className="gui-input"
                                                placeholder="Last Name"
                                                defaultValue={user.last_name}
                                                onChange={this.onFieldChange.bind(this, 'last_name')}
                                            />
                                            <span className="field-icon"><i className="fa fa-user"></i></span>
                                        </label>
                                        {
                                            errorMessageLastName
                                        }
                                    </div>
                                </div>
                                <div className="frm-row">
                                    <div className="section colm colm12">
                                        <div className="spacer-b0">
                                            <div className="tagline">
                                                <span>Payment Details</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="section colm colm12">
                                    <label
                                        className={Object.keys(errorMessageCardName).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                        <input
                                            type="text"
                                            name="cardname"
                                            id="cardname"
                                            className="gui-input"
                                            placeholder="Name on card..."
                                            defaultValue={!user.billing_profile ? '' : user.billing_profile.credit_card.first_name + ' ' + user.billing_profile.credit_card.last_name
                                            }
                                            onChange={this.onFieldChange.bind(this, 'cardname')}
                                        />
                                        <span className="field-icon"><i className="fa fa-user"></i></span>
                                    </label>
                                    {
                                        errorMessageCardName
                                    }
                                </div>
                                <div className="frm-row">
                                    <div className="section colm colm6">
                                        <label
                                            className={Object.keys(errorMessageCardNumber).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="cardno"
                                                id="lastname"
                                                className="gui-input"
                                                placeholder="Card number..."
                                                defaultValue={!user.billing_profile ? '' : user.billing_profile.credit_card.number}
                                                onChange={this.onFieldChange.bind(this, 'cardno')}
                                            />
                                            <span className="field-icon"><i className="fa fa-credit-card"></i></span>
                                        </label>
                                        {
                                            errorMessageCardNumber
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label
                                            className={Object.keys(errorMessageSecurityNumber).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="secno"
                                                id="secno"
                                                className="gui-input"
                                                placeholder="Security number..."
                                                onChange={this.onFieldChange.bind(this, 'secno')}
                                            />
                                            <b className="tooltip tip-left-top"><em> This is a three or four diigit
                                                number at the back of your card </em></b>
                                            <span className="field-icon"><i className="fa fa-barcode"></i></span>
                                        </label>
                                        {
                                            errorMessageSecurityNumber
                                        }
                                    </div>
                                </div>
                                <div className="frm-row">
                                    <div className="section colm colm6">
                                        <label for="cardmonth"
                                               className={Object.keys(errorMessageCardMonth).length > 0 ? 'field select state-error' : 'field select'}>
                                            <select
                                                id="cardmonth"
                                                name="cardmonth"
                                                onChange={this.onFieldChange.bind(this, 'cardmonth')}
                                            >
                                                <option
                                                    value={!user.billing_profile ? '' : user.billing_profile.credit_card.expiry_month}>
                                                    {!user.billing_profile ? 'Expiry month...' : user.billing_profile.credit_card.expiry_month}
                                                </option>
                                                <option value="01">01 - Jan</option>
                                                <option value="02">02 - Feb</option>
                                                <option value="03">03 - Mar</option>
                                                <option value="04">04 - Apr</option>
                                                <option value="05">05 - May</option>
                                                <option value="06">06 - Jun</option>
                                                <option value="07">07 - Jul</option>
                                                <option value="08">08 - Aug</option>
                                                <option value="09">09 - Sep</option>
                                                <option value="10">10 - Oct</option>
                                                <option value="11">11 - Nov</option>
                                                <option value="12">12 - Dec</option>
                                            </select>
                                            <i className="arrow double"></i>
                                        </label>
                                        {
                                            errorMessageCardMonth
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label
                                            className={Object.keys(errorMessageCardYear).length > 0 ? 'field select state-error' : 'field select'}>
                                            <select
                                                id="cardyear"
                                                name="cardyear"
                                                onChange={this.onFieldChange.bind(this, 'cardyear')}
                                            >
                                                <option
                                                    value={!user.billing_profile ? '' : user.billing_profile.credit_card.expiry_year}>
                                                    {!user.billing_profile ? 'Expiry year...' : '20' + user.billing_profile.credit_card.expiry_year}
                                                </option>
                                                <option value="14">2014</option>
                                                <option value="15">2015</option>
                                                <option value="16">2016</option>
                                                <option value="17">2017</option>
                                                <option value="18">2018</option>
                                                <option value="19">2019</option>
                                                <option value="20">2020</option>
                                                <option value="21">2021</option>
                                                <option value="22">2022</option>
                                                <option value="23">2023</option>
                                                <option value="24">2024</option>
                                                <option value="25">2025</option>
                                                <option value="26">2026</option>
                                            </select>
                                            <i className="arrow double"></i>
                                        </label>
                                        {
                                            errorMessageCardYear
                                        }
                                    </div>
                                </div>
                                <div className="frm-row">
                                    <div className="section colm colm12">
                                        <div className="spacer-b0">
                                            <div className="tagline">
                                                <span>Street Address</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="frm-row">
                                    <div className="section colm colm6">
                                        <label for="mobile" className="field-label">Phone</label>
                                        <label
                                            className={Object.keys(errorMessagePhoneNumber).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <InputElement
                                                mask="+\19999999999"
                                                maskChar=" "
                                                type="tel"
                                                name="mobile"
                                                id="mobile"
                                                className="gui-input"
                                                placeholder="Tel / mobile"
                                                defaultValue={user.phone_number}
                                                onChange={this.onFieldChange.bind(this, 'mobile')}
                                            />
                                            <span className="field-icon"><i
                                                className="fa fa-phone-square"></i></span>
                                        </label>
                                        {
                                            errorMessagePhoneNumber
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label for="firstaddr" className="field-label">Address</label>
                                        <label
                                            className={Object.keys(errorMessageFirstAddr).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="firstaddr"
                                                id="firstaddr"
                                                className="gui-input"
                                                placeholder="Street address"
                                                defaultValue={user.address}
                                                onChange={this.onFieldChange.bind(this, 'firstaddr')}
                                            />
                                            <span className="field-icon"><i className="fa fa-map-marker"></i></span>
                                        </label>
                                        {
                                            errorMessageFirstAddr
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label for="city" className="field-label">City</label>
                                        <label for="city"
                                               className={Object.keys(errorMessageCity).length > 0 ? "field select state-error" : 'field select'}>
                                            <select
                                                id="city"
                                                name="city"
                                                onChange={this.onFieldChange.bind(this, 'city')}
                                                defaultValue={user.city}
                                            >
                                                <option value="">Choose city</option>
                                                {this.props.cities.map(item => (
                                                    <option key={item.id} value={item.name}  selected={user.city == item.name}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <i className="arrow double"></i>
                                        </label>
                                        {
                                            errorMessageCity
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label for="zip" className="field-label">Zip / Postal Code</label>
                                        <label
                                            className={Object.keys(errorMessagePostalCode).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="zip"
                                                id="zip"
                                                className="gui-input"
                                                placeholder="Zip / Postal Code"
                                                defaultValue={user.postal_code}
                                                onChange={this.onFieldChange.bind(this, 'zip')}
                                            />
                                            <span className="field-icon"><i className="fa fa-certificate"></i></span>
                                        </label>
                                        {
                                            errorMessagePostalCode
                                        }
                                    </div>
                                </div>
                                {/* <div className="promocode">
                                    <div className="frm-row">
                                        <div className="section colm colm12">
                                            <div className="spacer-b0">
                                                <div className="tagline">
                                                    <span>Promo + Share</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="credits">
                                        <p className="promocode-p">Available credits</p>
                                        <div className="thetotals">
                                            <h1 className="page_totals">$<span>{user.credits_available}</span></h1>
                                        </div>
                                    </div>
                                    <div className="section">
                                        <p className="promocode-p">Have a promo code?</p>
                                        <div className="smart-widget sm-left sml-120">
                                            <label className={Object.keys(errorMessagePromoCode).length > 0 ? "field prepend-icon state-error" : 'field'}>
                                                <input
                                                    type="text"
                                                    name="sm"
                                                    id="promocode"
                                                    className="gui-input"
                                                    placeholder="Enter your code"
                                                    onChange={this.onFieldChange.bind(this, 'promoCode')}
                                                />
                                            </label>
                                            {
                                                errorMessagePromoCode
                                            }
                                            <label
                                                for="sm"
                                                className="button"
                                                onClick={this.btnPromoCode}
                                            > Apply </label>
                                        </div>
                                    </div>
                                </div>
                                */}
                                <div className="frm-row">
                                    <div className="section colm colm12">
                                        <div className="spacer-b0">
                                            <div className="tagline">
                                    <span>Password
                                        {
                                            !this.state.isChangePassword ?
                                                (
                                                    <a
                                                        className="openSlickModal-1 manualLabel password-link-open"
                                                        onClick={this.activeChangePassword}
                                                    > Change</a>
                                                ) :
                                                (
                                                    <a
                                                        className="openSlickModal-1 manualLabel password-link-close"
                                                        onClick={this.activeChangePassword}
                                                    > Cancel</a>
                                                )
                                        }

                                    </span>
                                    <span
                                        onClick={this.onBtnBack.bind(this, 'editAccount')}
                                    >
                                        View Appointments
                                    </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.isChangePassword &&
                                    <div className="password-elements">
                                        <div className="section">
                                            <label for="oldPssword" className="field-label">Old password</label>
                                            <label
                                                className={Object.keys(errorMessageOldPassword).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                                <input
                                                    type="password"
                                                    name="oldPassword"
                                                    id="oldPassword"
                                                    className="gui-input"
                                                    placeholder="Old Password"
                                                    onChange={this.onFieldChange.bind(this, 'oldPassword')}
                                                />
                                                <span className="field-icon"><i className="fa fa-lock"></i></span>
                                            </label>
                                            {
                                                errorMessageOldPassword
                                            }
                                        </div>
                                        <div className="section">
                                            <label for="newPassword" className="field-label">New password</label>
                                            <label
                                                className={Object.keys(errorMessagePassword).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                                <input
                                                    type="password"
                                                    name="newPassword"
                                                    id="newpassword"
                                                    className="gui-input"
                                                    placeholder="New Password"
                                                    onChange={this.onFieldChange.bind(this, 'newPassword')}
                                                />
                                                <span className="field-icon"><i className="fa fa-lock"></i></span>
                                            </label>
                                            {
                                                errorMessagePassword
                                            }
                                        </div>
                                        <div className="section">
                                            <label for="confirmPassword" className="field-label">Confirm
                                                password</label>
                                            <label
                                                className={Object.keys(errorMessagePasswordConfirmation).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                                <input
                                                    type="password"
                                                    name="confirmPassword"
                                                    id="confirmPassword"
                                                    className="gui-input"
                                                    placeholder="Confirm Password"
                                                    onChange={this.onFieldChange.bind(this, 'confirmPassword')}
                                                />
                                                <span className="field-icon"><i className="fa fa-unlock-alt"></i></span>
                                            </label>
                                            {
                                                errorMessagePasswordConfirmation
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="controls">
                                <div className="sendit">
                                    <button
                                        type="submit"
                                        className="button btn-primary"
                                        onClick={this.clickEditAccount}
                                    > Update Account
                                    </button>
                                </div>
                            </div>
                            <div className="text-center backer">
                                <a
                                    href="#"
                                    className="back"
                                    onClick={this.onBtnBack.bind(this, 'editAccount')}
                                >&larr;  Back</a></div>
                        </fieldset>
                    </form>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/EditAccount.js
 **/